export enum CookieKey {
  Dismissed = "th-onboarding__wizard-dismissed",
}

/**
 * Sets cookie with given key, value, and expiration.
 * @param key - cookie key/name
 * @param value - cookie value, default is "true"
 * @param expiration - expiration in ms, default is 1 year
 */
export function setCookie(
  key: CookieKey,
  value = "true",
  expiration = 360 * 24 * 60 * 60 * 1000
) {
  const date = new Date();
  date.setTime(date.getTime() + expiration);
  const expires = date.toUTCString();
  document.cookie = `${key}=${value}; expires=${expires}; path=/; secure`;
}
